export const INVALID_24HOUR_FORMAT_MSG = 'Must be a valid 24hr value';
export const INVALID_AM_PM_FORMAT_MSG = 'Must be a valid "HH:mm am/pm" time value';
